var map = {
	"./collibra.png": 1646,
	"./collibraBW.png": 3939,
	"./databricks.png": 856,
	"./databricksBW.png": 3541,
	"./gc-partners.png": 6366,
	"./gc-partnersBW.png": 4051,
	"./hashicorp.png": 5345,
	"./looker.png": 3402,
	"./lookerBW.png": 5671,
	"./secoda.png": 2161,
	"./secodaBW.png": 9224
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1565;